import React from 'react';
import PropTypes from 'prop-types';

import MediaButton from '../../ui/MediaButton';
import MediaIcon from '../../ui/MediaIcon';

export default function VideoContent(props) {
  return (
    <div className="mediaBlockContent">
      <iframe
        className="videoFrame"
        src={props.src}
        allowFullScreen
        title="Видеоплеер"
      />

      <MediaButton position="top" onClick={props.onButtonClick} aria-label="Удалить">
        <MediaIcon type="remove" />
      </MediaButton>
    </div>
  );
}

VideoContent.propTypes = {
  src: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
};
